import React, { forwardRef, useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import './TextEditor.css';

const TextEditor = forwardRef(({ onTextChange }, ref) => {
  const editorRef = useRef(null);

  useEffect(() => {
    const quill = new Quill(editorRef.current, {
      modules: {
        toolbar: true,
      },
      placeholder: 'Introduceți textul aici...',
      theme: 'snow',
    });

    quill.on('text-change', () => {
      if (onTextChange) {
        onTextChange(quill.root.innerHTML);
      }
    });
  }, [ref]);

  return <div ref={editorRef} className="editor rounded-editor"></div>;
});

export default TextEditor;
